//#region ../icons/dist/html/compat/chevron.js
const chevronIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" fill=\"none\" aria-hidden=\"true\" viewBox=\"0 0 18 18\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"m7 4 5 5-5 5\"/></svg>";
//#endregion
export { chevronIcon };

//# sourceMappingURL=chevron.js.map